export const styles = {
  headContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px',
    cursor: 'pointer',
  },
  headContainerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 12px 12px 12px',
    cursor: 'pointer',
  },
  logoContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  AppBarTitle: {
    fontSize: '21px',
    fontWeight: 500,
    color: '#242528',
  },
  appbarContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 20px',
    cursor: 'pointer',
  },
  loginBtn: {
    borderRadius: '7px',
  },
  profileIcon: {
    marginRight: '20px',
    position: 'relative',
    cursor: 'pointer',
  },
  cartQuantity: {
    position: 'absolute',
    right: '-7px',
    top: '-5px',
    background: '#888D95',
    color: '#ffffff',
    width: '16px',
    height: '16px',
    textAlign: 'center',
    borderRadius: '50%',
    fontSize: '10px',
    // marginRight:'8px'
  },
};
